import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import _ from "lodash";

import Dropdown from "../../../Common/Dropdown";
import Tools from "../../../../helpers/tools";

function ChangeCultureDropdown({onChange, value}) {
    const cultures = useSelector(state => _.get(state, `culture.allLanguages`, []));
    const priorityCountries = useSelector(state => _.get(state,`environment.priorityCountries`));
    const cultureItems = useMemo( ()=>{
        return cultures.reduce(function(result, item){
            const countryCode = Tools.substringCountryCode(item.culture);
            if(!(Object.values(priorityCountries).indexOf(countryCode) > -1)){
                result.push({
                    name: item.culture,
                    code: item.culture
                });
            }
            return result;
        },[]);
    }, [cultures, priorityCountries]);

    return (<Dropdown
            placeholder={`Select a locale`}
            dropdownItems={_.orderBy(cultureItems, [`name`], [`asc`])}
            value={value}
            onChange={onChange}/>
    );
}

ChangeCultureDropdown.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string
};

export default ChangeCultureDropdown;